// extracted by mini-css-extract-plugin
module.exports = {"pokemonContainer":"PokemonsContainer_pokemonContainer__rD675"};